export const CONFIG = {
	timeout: 30000,
};

export const API_VERSIONS = {
	DEFAULT: '/v1',
	V1: '/v1',
};

const routeList = [
	'/api/X4bUser/CreateUser',
	'/api/X4bUser/Activate',
	'/api/X4bUser/ResendActivationEmail',
	'/api/X4bUser/SendPasswordResetEmail',
	'/api/X4bUser/ResetPassword',
	'/api/X4bUser/CheckEmailAvailability',
	'/Login',
	'/api/otp/CheckOtp',
	'/api/Otp/ResendOTP',
	'/Token',
	'/travel-program',
	'/api/GetGoogleOAuthUrl',
	'/api/Xpress/CheckGoogleUser',
	'/api/X4bUser/LoginViaGoogle',
	'/api/Config/GetFrontendConfig',

	'/api/X4bEmployee/CreateEmployee',
	'/api/X4bEmployee/UpdateEmployee',
	'/api/X4bEmployee/GetEmployee',
	'/api/X4bEmployee/GetEmployeeDetails',
	'/api/X4bEmployee/GetEmployeeList',
	'/api/X4bEmployee/GetEmployeeListForApproval',
	'/api/X4bEmployee/GetEmployeeListForOnboarding',
	'/api/X4bEmployee/DeleteEmployees',
	'/api/X4bEmployee/ApproveEmployees',
	'/api/X4bEmployee/DeclineEmployees',
	'/api/X4bEmployee/DeclineEmployees',
	'/api/X4bEmployee/DownloadCsvTemplate',
	'/api/X4bEmployee/BulkProcess',

	'/api/X4bUser/GetOnboardingProgram',
	'/api/X4bUser/CreateOnboardingProgram',
	'/api/X4bUser/UpdateOnboardingProgram',

	'/api/X4bUser/GetOnboardingSteps',
	'/api/X4bUser/UpdateOnboardingSteps',

	'/api/X4bUser/GetNotifications',
	'/api/X4bUser/GetUserSetting',
	'/api/X4bUser/UpdateUserSetting',
	'/api/X4bUser/UpdateUserForwardProgramReceipts',
	'/api/X4bUser/GetCompanyAdmins',
	'/api/X4bUser/GetById',
	'/api/X4bUser/UpdateUser',
	'/api/X4bUser/RemoveUser',
	'/api/X4bUser/SetEmployeePassword',

	'/api/X4bBilling/UpdateBillingInfo',
	'/api/X4bBilling/GetBillingInfo',
	'/api/X4bBilling/GetProvinces',
	'/api/X4bBilling/GetCities',
	'/api/X4bBilling/GetBillingInfoRequests',
	'/api/X4bBilling/ApproveBillingInfoRequest',
	'/api/X4bBilling/DeclineBillingInfoRequest',


	'/api/Budget/CreateBudgetRequest',
	'/api/Budget/GetBudgetRequestList',
	'/api/Budget/GetBudgetSummary',
	'/api/Budget/ApproveBudgetRequest',
	'/api/Budget/DeclineBudgetRequest',


	'/api/X4bGroup/CreateGroup',
	'/api/X4bGroup/GetGroups',
	'/api/X4bGroup/GetGroupEmployees',
	'/api/X4bGroup/InviteExisting',

	'/api/X4bActivity/GetActivityList',
	'/api/X4bActivity/GetActivityAutocomplete',
	'/api/X4bActivity/GetActivityBlockList',
	'/api/X4bActivity/ExportActivityList',
	'/api/X4bActivity/GetServicesAndPrices',
	'/api/X4bActivity/PlaceOrder',
	'/api/X4bActivity/CancelOrder',
	'/api/X4bActivity/RebookOrder',
	'/api/X4bActivity/GetGoogleFleetToken',
	'/api/X4bActivity/GetGoogleMapRouting',
	'/api/X4bActivity/GetLocationHistory',
	'/api/X4bActivity/GetCompanyPoints',
	'/api/X4bActivity/GetCompanyRecentPoints',
	'/api/X4bActivity/SaveCompanyPoint',
	'/api/X4bActivity/GetOrderDetails',
	'/api/X4bActivity/DeleteCompanyPoint',
	'/api/X4bActivity/EmailReceipt',


	'/api/X4bProgram/GetProgramList',

	// Concierge
	'/api/X4bConcierge/UploadLostItemFile',
	'/api/X4bConcierge/ReportLostItem',

	'/api/X4bFile/UploadFile',

	'/api/X4bCompanyTrustedDomain/GetTrustedDomains',
	'/api/X4bCompanyTrustedDomain/DeleteTrustedDomain',
	'/api/X4bCompanyTrustedDomain/AddTrustedDomain',

	'/api/payments/GetInsights4Spending',
	'/api/payments/GetInsights4Volume',
	'/api/payments/GetInsightsOther',
	'/api/payments/ExportInsights',
	'/api/payments/GetPaymentList',
	'/api/payments/GetPaymentAutocomplete',
	'/api/payments/GetTopUpStatements',
	'/api/payments/ExportAccountStatementPdf',
	'/api/payments/ExportAccountStatementCsv',

	'/api/payment-cards/GetXenditConfig',
	'/api/payment-cards/GetPaymentMethodRequests',
	'/api/payment-cards/ApprovePaymentMethodRequest',
	'/api/payment-cards/DeclinePaymentMethodRequest',
	'/api/payment-cards/CreatePaymentMethodChangeRequest',
	'/api/payment-cards/GetList',
	'/api/payment-cards/Delete',
	'/api/payment-cards/SetDefault',

] as const;

// 2. Create a type for all route paths
export type EndpointPath = typeof routeList[number];

// 3. Create a routes object with keys and values as the route strings
export const ENDPOINTS: { [K in EndpointPath]: K } = Object.fromEntries(
	routeList.map(r => [r, r])
) as { [K in EndpointPath]: K };
